const config = {
  development: {
    PCA_PREDICT_FIND_URL: process.env.REACT_APP_PCA_PREDICT_FIND_URL,
    PCA_PREDICT_RETRIEVE_URL: process.env.REACT_APP_PCA_PREDICT_RETRIEVE_URL,
    POST_LOG_URL: process.env.REACT_APP_POST_LOG_URL,
  },
  production: {
    PCA_PREDICT_FIND_URL: process.env.REACT_APP_PCA_PREDICT_FIND_URL,
    PCA_PREDICT_RETRIEVE_URL: process.env.REACT_APP_PCA_PREDICT_RETRIEVE_URL,
    POST_LOG_URL: process.env.REACT_APP_POST_LOG_URL,
  },
};

export const { PCA_PREDICT_FIND_URL, PCA_PREDICT_RETRIEVE_URL, POST_LOG_URL } =
  config[process.env.NODE_ENV || 'development'];
